import { render } from "./componentSeparator.vue?vue&type=template&id=027206c5"
import script from "./componentSeparator.vue?vue&type=script&lang=js"
export * from "./componentSeparator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__